import { defineComponent as E, inject as p, ref as u, watchEffect as R, createElementBlock as x, openBlock as s, createBlock as c, createCommentVNode as f, renderSlot as C, unref as e, normalizeClass as r, withCtx as B } from "vue";
import { t as S } from "./locale.js";
import v from "./Checkbox.js";
import { D as w } from "./DataView.keys-aSOnA4AD.js";
import "lodash-es/cloneDeep";
import "lodash-es/uniqueId";
import "./Illustration.vue_vue_type_script_setup_true_lang-BBqgoJO8.js";
import { T as N } from "./Table.keys-LHQf6FEH.js";
import h from "./TableHeaderCell.js";
import { _ as g } from "./_plugin-vue_export-helper-CHgC5LLL.js";
const A = /* @__PURE__ */ E({
  __name: "TableHeaderRow",
  props: {
    allRowsSelected: { type: Boolean, default: !1 },
    someRowsSelected: { type: Boolean, default: !1 }
  },
  emits: ["select"],
  setup(_, { emit: b }) {
    const a = _, k = b, n = p(N.key);
    if (!n)
      throw new Error("TableHeaderRow must be used within a Table component");
    const { hasCustomExpandToggle: y, isExpandable: T, isSelectable: i } = n, { hasToolbar: t } = p(w.key, w.defaults), m = u(0), l = u();
    function d() {
      k("select"), m.value++;
    }
    return R(() => {
      l.value && (t != null && t.value && i.value ? l.value.getElementsByTagName("th")[0].setAttribute("colspan", 2) : l.value.getElementsByTagName("th")[0].setAttribute("colspan", 1));
    }), (o, H) => (s(), x("tr", {
      ref_key: "headerRow",
      ref: l,
      class: "stash-table-header-row",
      "data-test": "stash-table-header-row"
    }, [
      !e(t) && e(i) ? (s(), c(h, {
        key: 0,
        class: r(["stash-table-header-row__selection-cell tw-min-w-[48px]", o.$style["row-control-cell"]])
      }, {
        default: B(() => [
          (s(), c(v, {
            key: m.value,
            class: r(o.$style["row-selection-checkbox"]),
            checked: a.allRowsSelected,
            indeterminate: a.someRowsSelected && !a.allRowsSelected,
            title: e(S)("ll.selectAll"),
            "onUpdate:indeterminate": d,
            "onUpdate:checked": d
          }, null, 8, ["class", "checked", "indeterminate", "title"]))
        ]),
        _: 1
      }, 8, ["class"])) : f("", !0),
      e(T) && !e(y) ? (s(), c(h, {
        key: 1,
        class: r(o.$style["row-control-cell"]),
        "data-test": "table-row-header-expansion-cell"
      }, null, 8, ["class"])) : f("", !0),
      C(o.$slots, "default")
    ], 512));
  }
}), I = {
  "row-selection-checkbox": "_row-selection-checkbox_1eq6o_2",
  "row-control-cell": "_row-control-cell_1eq6o_8"
}, $ = {
  $style: I
}, L = /* @__PURE__ */ g(A, [["__cssModules", $]]);
export {
  L as default
};
//# sourceMappingURL=TableHeaderRow.js.map
